<template>
	<b-container fluid class="p-2 p-md-0 m-0 m-md-4 m-lg-4">
		<b-card class="m-0" no-body>
			<b-card-header class="p-2 p-md-3">Alerts</b-card-header>
      <b-card-body class="p-2 p-md-3">
        <b-tabs>
          <b-tab title="Alert Log" active class="p-2 p-md-3">
            <b-row>
              <b-col sm="12" md="6" lg="6" xl="6">
                <b-form-group label="Start Datetime" horizontal>
                  <datetime input-class="form-control" v-model="date.start" input-id="startDate" type="datetime"
                    format="yyyy-LL-dd HH:mm:ss" auto value-zone="local" placeholder="Select Date" :max-datetime="date.max"
                    class="theme-msi-orange">
                  </datetime>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="6" lg="6" xl="6">
                <b-form-group label="End Datetime" horizontal>
                  <datetime input-class="form-control" v-model="date.end" input-id="endDate" type="datetime"
                    format="yyyy-LL-dd HH:mm:ss" auto value-zone="local" placeholder="Select Date" :min-datetime="date.start"
                    :max-datetime="date.max" class="theme-msi-orange">
                  </datetime>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="6" lg="6" xl="6">
                <gcu-dropdown v-model="selectedGCUs" multiple cacheKey="alerts"></gcu-dropdown>
              </b-col>
            </b-row>

            <div class="d-inline-flex align-items-center my-2">
              <h6 class="mr-2 mb-0 text-center">Filter By</h6>
              <font-awesome-icon
                size="sm"
                class="ml-2 h-100"
                style="cursor: pointer; user-select: none;"
                :icon="filterCollapsed ? 'chevron-down' : 'chevron-up'"
                v-b-toggle.filterCollapse />
            </div>
            <b-collapse id="filterCollapse" @show="filterCollapsed = false" @hide="filterCollapsed = true">
              <b-row>
                <b-col sm="12" md="6" lg="6" xl="6">
                  <b-form-group label="Type" horizontal>
                    <multiselect v-model="types" placeholder="Select Type" :options="typeOptions"
                      selectLabel="" deselectLabel="Remove" multiple>
                    </multiselect>
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="6" lg="6" xl="6">
                  <b-form-group label="Include in Desc" horizontal>
                    <b-form-input v-model="include" type="text" id="include" placeholder="word 1, word 2, word 3, word 4"
                      :state="includeArray.length <= 4 ? null : false" />
                    <b-form-invalid-feedback> Max: 4, Current: {{ includeArray.length }}</b-form-invalid-feedback>

                  </b-form-group>
                </b-col>
                <b-col sm="12" md="6" lg="6" xl="6">
                  <b-form-group label="Exclude from Desc" horizontal>
                    <b-form-input v-model="exclude" type="text" id="exclude" placeholder="word 1, word 2, word 3, word 4"
                      :state="excludeArray.length <= 4 ? null : false" />
                    <b-form-invalid-feedback> Max: 4, Current: {{ excludeArray.length }}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-collapse>

            <div class="d-flex justify-content-end">
              <img style="margin-right: 15px;" v-show="loading" src="img/msi_spinner.gif" height="25" width="25">
              <b-button class="ms-btn-primary" :disabled="!passSearch" @click="handleSearch">Search</b-button>
            </div>

            <div class="d-flex flex-column mx-md-2 mx-lg-3 mx-xl-4 mt-4">
              <b-table responsive="sm" :items="items" :fields="fields" :per-page="perPage" :current-page="currentPage" show-empty striped></b-table>
              <div class="d-flex justify-content-end">
                <nav>
                  <b-pagination v-if="items.length > perPage" :total-rows="totalRows" :per-page="perPage" v-model="currentPage"
                    prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                </nav>
              </div>
            </div>
          </b-tab>
          <b-tab title="Email Subscriptions" >
            <h4>Placeholder</h4>
          </b-tab>
        </b-tabs>
      </b-card-body>
		</b-card>
	</b-container>
</template>

<script>
import GcuDropdown from '../components/GcuDropdown';
import Multiselect from 'vue-multiselect';
import moment from 'moment';

const url = 'https://api.morgansolar.xyz/api/v1/alerts/log';

export default {
	name: 'alerts',
	components: {
		GcuDropdown,
		Multiselect
	},
	data() {
		return {
			selectedGCUs: [],
			types: [],
			date: {
				start: '',
				end: '',
				max: moment(new Date()).format()
			},
			include: '',
			exclude: '',
			typeOptions: ['REPORT', 'COMM', 'WIND', 'OTHER', 'ALERT'],
			items: [],
			fields: {
				date: {
					label: 'Date',
					class: 'alert-tb-date'
				},
				data_type: {
					label: 'Type',
					class: 'alert-tb-type'
				},
				gcu: {
					label: 'GCU',
					class: 'alert-tb-gcu'
				},
				error_description: {
					label: 'Description',
					class: 'alert-tb-desc'
				}
      },
      filterCollapsed: true,
			currentPage: 1,
			perPage: 10,
			loading: false
		};
	},
	methods: {
		handleSearch() {
			this.loading = true;
			this.items = [];
			this.currentPage = 1;

			const { selectedGCUs, date, types, includeArray, excludeArray } = this;
			const startDate = moment(date.start, moment.ISO_8601).format('YYYY-MM-DD HH:mm:ss');
			const endDate = moment(date.end, moment.ISO_8601).format('YYYY-MM-DD HH:mm:ss');
			const gcu = selectedGCUs.map((val) => val.id);
			const query = { startDate, endDate, gcu };

			// Optional query parameters
			if (types.length > 0) query.type = types;
			if (includeArray.length > 0) query.include = includeArray;
			if (excludeArray.length > 0) query.exclude = excludeArray;

			this.$api.get(`/v1/alerts/log`, { query })
				.then(results => {
					if (results.errors) {
						this.items = results.errors;
					}

					this.loading = false;
				})
				.catch(() => {
					this.showError();
					this.loading = false;
				});
		}
	},
	computed: {
		totalRows() {
			return this.items.length;
		},
		passSearch() {
			const isGcuSelected = this.selectedGCUs && this.selectedGCUs.length > 0;
			const isStartDateSelected = this.date.start.length > 0;
			const isEndDateSelected = this.date.end.length > 0;
			const isInclude = this.includeArray.length <= 4;
			const isExclude = this.excludeArray.length <= 4;
			return isGcuSelected && isStartDateSelected && isEndDateSelected && isInclude && isExclude;
		},
		includeArray() {
			const inc = this.include.trim();
			if (inc) return inc.split(',').map((inc) => inc.trim());
			return [];
		},
		excludeArray() {
			const exc = this.exclude.trim();
			if (exc) return exc.split(',').map((exc) => exc.trim());
			return [];
		}
  },
  notifications: {
    showError: {
      type: 'error',
      title: 'Error',
      message: 'An error has occurred.'
    }
  }
};
</script>

<style>
#startDate,
#endDate {
	height: 43px;
}

#include,
#exclude {
	height: 43px;
}

.alert-tb-date {
	width: 15%;
}
.alert-tb-type {
	width: 10%;
}
.alert-tb-gcu {
	width: 20%;
}
.alert-tb-desc {
	width: 55%;
}
</style>
